module.exports = new __parcel__URL__("magnifying-glass.26424ba7.svg").toString();